"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { style: { "border-bottom": "1px solid #d9d0c7" } };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "vehicle_code" };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "vehicle_name" };
const _hoisted_7 = { style: { "border-bottom": "1px solid #d9d0c7" } };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { class: "driver_code" };
const _hoisted_10 = { key: 1 };
const _hoisted_11 = { class: "driver_name" };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { class: "vehicle_status" };
const _hoisted_14 = { key: 1 };
const _hoisted_15 = { class: "speed" };
const _hoisted_16 = { key: 3 };
const _hoisted_17 = { key: 4 };
const _hoisted_18 = { class: "temperature1" };
const _hoisted_19 = { class: "temperature2" };
const _hoisted_20 = { class: "temperature3" };
const _hoisted_21 = { class: "temperature4" };
const _hoisted_22 = ["data-holding_id", "data-company_id", "data-section_id", "data-record_id"];
const _hoisted_23 = { key: 5 };
const _hoisted_24 = { class: "updated_at" };
const moment_1 = __importDefault(require("moment"));
const vue_3 = require("vue");
const BssMapAddress_vue_1 = __importDefault(require("./BssMapAddress.vue"));
const BssMapLatLng_vue_1 = __importDefault(require("./BssMapLatLng.vue"));
const category_key = 'v_infobox_settings';
exports.default = (0, vue_1.defineComponent)({
    __name: 'BssMapVehicleInfobox',
    props: {
        data: {},
        movementSettings: {}
    },
    setup(__props) {
        var _a;
        const props = __props;
        const messages = (0, vue_3.inject)('messages');
        const id = props.data.record_id;
        const infobox_messages = messages.v_infobox;
        const checkMovementSetting = window.checkMovementSetting;
        const vehicle_status = (0, vue_3.computed)(() => {
            const _vehicle_status_message = getVehicleStatusMessage(props.data.vehicle_status, props.data.luggage_status);
            let elapsed = '';
            const data = props.data;
            if (data.work_start_time !== null &&
                (data.vehicle_status == '2' ||
                    data.vehicle_status == '3' ||
                    data.vehicle_status == '4' ||
                    data.vehicle_status == '5' ||
                    data.vehicle_status == '6' ||
                    data.vehicle_status == '11' ||
                    data.vehicle_status == '12' ||
                    data.vehicle_status == '9')) {
                let _hour = 0;
                let _min = (0, moment_1.default)().diff((0, moment_1.default)(data.work_start_time), 'minutes');
                if (_min > 60) {
                    _hour = Math.floor(_min / 60);
                    _min = _min % 60;
                }
                if (_hour > 0) {
                    elapsed = _hour + '時間';
                }
                elapsed += _min + '分';
                elapsed = '（' + elapsed + '経過）';
            }
            let ig = '';
            if (data.vehicle_status != '1' && data.vehicle_status != '99') {
                ig = ' (IG-OFF)';
                if (data.ope_status > 0) {
                    ig = ' (IG-ON)';
                }
            }
            return _vehicle_status_message + elapsed + ig;
        });
        const speed = (0, vue_3.computed)(() => (props.data.vehicle_status == 99 ? 0 : props.data.average_speed));
        const t1 = (0, vue_3.computed)(() => props.data.temperature1 != '3276.7' && props.data.temperature1 != '3276.6' ? props.data.temperature1 : '---');
        const t2 = (0, vue_3.computed)(() => props.data.temperature2 != '3276.7' && props.data.temperature2 != '3276.6' ? props.data.temperature2 : '---');
        const t3 = (0, vue_3.computed)(() => props.data.temperature3 != '3276.7' && props.data.temperature3 != '3276.6' ? props.data.temperature3 : '---');
        const t4 = (0, vue_3.computed)(() => props.data.temperature4 != '3276.7' && props.data.temperature4 != '3276.6' ? props.data.temperature4 : '---');
        const updated_at = (0, vue_3.computed)(() => (0, moment_1.default)(props.data.time).format('YYYY/MM/DD HH:mm:ss'));
        const section_id = ((_a = props.data) === null || _a === void 0 ? void 0 : _a.section_id) || '';
        const is_visible_item1 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'vehicle_code', props.movementSettings)); // 1.車両コード
        const is_visible_item2 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'vehicle_name', props.movementSettings)); // 2.車両番号
        const is_visible_item3 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'driver_code', props.movementSettings)); // 3.乗務員コード
        const is_visible_item4 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'driver_name', props.movementSettings)); // 4.乗務員名
        const is_visible_item5 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'vehicle_status', props.movementSettings)); // 5.車両状態
        const is_visible_item6 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'speed', props.movementSettings)); // 6.速度
        const is_visible_item7 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'latlon', props.movementSettings)); // 7.緯度・経度
        const is_visible_item8 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'temperature', props.movementSettings)); // 8.温度
        const is_visible_item9 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'updated_at', props.movementSettings)); // 9.最終更新日時
        const is_visible_item10 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'address', props.movementSettings)); // 10.住所
        function getVehicleStatusMessage(vehicle_status, luggage_status) {
            let message = '';
            const _vehicle_status = (vehicle_status || '').toString();
            const _luggage_status = (luggage_status || '').toString();
            if (messages.vehicle_status_types.hasOwnProperty(_vehicle_status)) {
                message += messages.vehicle_status_types[_vehicle_status];
            }
            if (_vehicle_status == '1' && messages.luggage_status_types.hasOwnProperty(_luggage_status)) {
                message += '(' + messages.luggage_status_types[_luggage_status] + ')';
            }
            return message;
        }
        return (_ctx, _cache) => {
            var _a, _b, _c;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: `infobox_vehicle_${(0, vue_2.unref)(id)}`,
                style: { "color": "#89684f" }
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (is_visible_item1.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).vehicle_code) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)((_a = _ctx.data.vehicle_code) !== null && _a !== void 0 ? _a : (0, vue_2.unref)(messages).is_not_exists_master_message), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item2.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).vehicle_name) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_6, (0, vue_2.toDisplayString)((_b = _ctx.data.vehicle_name) !== null && _b !== void 0 ? _b : (0, vue_2.unref)(messages).is_not_exists_master_message), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                    (is_visible_item3.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).driver_code) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_9, (0, vue_2.toDisplayString)(Number(_ctx.data.driver_code)), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item4.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).driver_name) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_11, (0, vue_2.toDisplayString)((_c = _ctx.data.driver_name) !== null && _c !== void 0 ? _c : ''), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createElementVNode)("div", null, [
                    (is_visible_item5.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).vehicle_status) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_13, (0, vue_2.toDisplayString)(vehicle_status.value), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item6.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).speed) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_15, (0, vue_2.toDisplayString)(speed.value) + " km/h", 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item7.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(BssMapLatLng_vue_1.default, {
                            key: 2,
                            latitude: _ctx.data.latitude_w,
                            longitude: _ctx.data.longitude_w
                        }, null, 8, ["latitude", "longitude"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item10.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_16, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).address) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", {
                                class: (0, vue_2.normalizeClass)(`vehicle-address-${_ctx.data.id}`)
                            }, [
                                (0, vue_2.createVNode)(BssMapAddress_vue_1.default, {
                                    lnglat: [_ctx.data.longitude_w, _ctx.data.latitude_w]
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).address_loading), 1)
                                    ]),
                                    _: 1
                                }, 8, ["lnglat"])
                            ], 2)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item8.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_17, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_name1) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_18, (0, vue_2.toDisplayString)(t1.value), 1),
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_deg) + ", " + (0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_name2) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_19, (0, vue_2.toDisplayString)(t2.value), 1),
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_deg) + ", " + (0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_name3) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_20, (0, vue_2.toDisplayString)(t3.value), 1),
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_deg) + ", " + (0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_name4) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_21, (0, vue_2.toDisplayString)(t4.value), 1),
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_deg) + " ", 1),
                            (0, vue_2.createElementVNode)("a", {
                                class: "btn btn-warning",
                                style: { "padding": "4px", "border-radius": "4px", "box-shadow": "none" },
                                onclick: "showTempGraph(this, event)",
                                "data-temperature_modal": "#temperature-modal",
                                "data-holding_id": _ctx.data.holding_id,
                                "data-company_id": _ctx.data.company_id,
                                "data-section_id": _ctx.data.section_id,
                                "data-record_id": _ctx.data.record_id
                            }, "グラフ", 8, _hoisted_22)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item9.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_23, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).updated_at) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_24, (0, vue_2.toDisplayString)(updated_at.value), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ])
            ], 8, _hoisted_1));
        };
    }
});
